module.exports =
    [
        {
            "Locations": "hauz qazi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6473149",
            "long": "77.2309034",
            "Created At": "2/27/2021 8:49"
        },
        {
            "Locations": "karol bagh, Delhi, India",
            "Crime": "Illegal",
            "lat": "28.6620158",
            "long": "77.2028422",
            "Created At": "11/21/2020 5:14"
        },
        {
            "Locations": "karol bagh, Delhi, India",
            "Crime": "Illegal",
            "lat": "28.6620158",
            "long": "77.2028422",
            "Created At": "11/20/2020 9:38"
        },
        {
            "Locations": "ali, Delhi, India",
            "Crime": "Murders",
            "lat": "28.6419097",
            "long": "77.2409817",
            "Created At": "3/29/2016 6:17"
        },
        {
            "Locations": "kalyanpuri, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.6261891",
            "long": "77.3209064",
            "Created At": "4/9/2021 12:03"
        },
        {
            "Locations": "inderpuri, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6323781",
            "long": "77.1504055",
            "Created At": "3/25/2021 14:53"
        },
        {
            "Locations": "kalyanpuri, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.6261891",
            "long": "77.3209064",
            "Created At": "3/24/2021 8:53"
        },
        {
            "Locations": "kalyanpuri, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.6261891",
            "long": "77.3209064",
            "Created At": "3/13/2021 1:48"
        },
        {
            "Locations": "kalyanpuri, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6261891",
            "long": "77.3209064",
            "Created At": "3/12/2021 6:35"
        },
        {
            "Locations": "shakarpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6358483",
            "long": "77.2863729",
            "Created At": "2/24/2021 10:17"
        },
        {
            "Locations": "kalyanpuri, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.6261891",
            "long": "77.3209064",
            "Created At": "2/16/2021 18:18"
        },
        {
            "Locations": "ghazipur, Delhi, India",
            "Crime": "Murders",
            "lat": "28.6413628",
            "long": "77.3419654",
            "Created At": "2/15/2021 15:50"
        },
        {
            "Locations": "ghazipur, Delhi, India",
            "Crime": "Murders",
            "lat": "28.6413628",
            "long": "77.3419654",
            "Created At": "2/15/2021 15:47"
        },
        {
            "Locations": "kalyanpuri, Delhi, India",
            "Crime": "Murders",
            "lat": "28.6261891",
            "long": "77.3209064",
            "Created At": "1/16/2021 6:03"
        },
        {
            "Locations": "ghazipur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6413628",
            "long": "77.3419654",
            "Created At": "1/11/2021 16:57"
        },
        {
            "Locations": "shakarpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6358483",
            "long": "77.2863729",
            "Created At": "1/8/2021 10:05"
        },
        {
            "Locations": "kalyanpuri, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6261891",
            "long": "77.3209064",
            "Created At": "1/3/2021 13:42"
        },
        {
            "Locations": "ghazipur, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6413628",
            "long": "77.3419654",
            "Created At": "8/15/2018 15:55"
        },
        {
            "Locations": "ghazipur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6413628",
            "long": "77.3419654",
            "Created At": "6/19/2018 10:17"
        },
        {
            "Locations": "kalyanpuri, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6261891",
            "long": "77.3209064",
            "Created At": "11/17/2017 17:05"
        },
        {
            "Locations": "shakarpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6358483",
            "long": "77.2863729",
            "Created At": "4/1/2016 4:33"
        },
        {
            "Locations": "sonia vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7299257",
            "long": "77.2581823",
            "Created At": "11/27/2020 10:47"
        },
        {
            "Locations": "new usmanpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6839046",
            "long": "77.2560551",
            "Created At": "11/3/2020 10:42"
        },
        {
            "Locations": "sonia vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7299257",
            "long": "77.2581823",
            "Created At": "10/31/2020 10:56"
        },
        {
            "Locations": "new usmanpur, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6839046",
            "long": "77.2560551",
            "Created At": "12/5/2018 4:32"
        },
        {
            "Locations": "seelampur, Delhi, India",
            "Crime": "Murders",
            "lat": "28.6748165",
            "long": "77.2718137",
            "Created At": "10/28/2018 4:21"
        },
        {
            "Locations": "alipur, Delhi, India",
            "Crime": "Murders",
            "lat": "28.8059955",
            "long": "77.1460706",
            "Created At": "9/26/2018 10:45"
        },
        {
            "Locations": "seelampur, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6748165",
            "long": "77.2718137",
            "Created At": "4/7/2016 6:46"
        },
        {
            "Locations": "harsh vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6781309",
            "long": "77.0914071",
            "Created At": "3/5/2016 2:42"
        },
        {
            "Locations": "seelampur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6748165",
            "long": "77.2718137",
            "Created At": "2/24/2016 3:09"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "4/7/2021 11:40"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "4/2/2021 15:48"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "4/1/2021 13:13"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "3/23/2021 9:28"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "3/23/2021 8:24"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "3/21/2021 11:33"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "3/20/2021 11:09"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "3/17/2021 12:37"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "2/7/2021 13:51"
        },
        {
            "Locations": "maurya enclave, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "2/4/2021 13:42"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "2/1/2021 11:19"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "1/28/2021 7:51"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "1/23/2021 8:12"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "1/17/2021 15:30"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "1/5/2021 12:27"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "11/21/2020 11:02"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "11/17/2020 18:09"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Illegal",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "11/4/2020 7:08"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "10/8/2020 7:53"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "10/7/2020 17:47"
        },
        {
            "Locations": "maurya enclave, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "9/26/2020 7:13"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "9/23/2020 3:34"
        },
        {
            "Locations": "maurya enclave, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "9/10/2020 9:16"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Illegal",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "8/28/2020 14:48"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "8/25/2020 7:53"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "8/12/2020 13:06"
        },
        {
            "Locations": "maurya enclave, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "8/3/2020 13:42"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "7/16/2020 9:41"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "6/21/2020 7:12"
        },
        {
            "Locations": "maurya enclave, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "3/18/2020 7:22"
        },
        {
            "Locations": "maurya enclave, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "12/21/2019 12:55"
        },
        {
            "Locations": "maurya enclave, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "10/18/2019 15:07"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "9/19/2019 6:18"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Illegal",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "9/13/2019 6:16"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "9/6/2019 5:20"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "9/3/2019 18:10"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "6/14/2019 18:31"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "6/8/2019 4:25"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "3/19/2019 15:55"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "10/27/2018 14:56"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "10/17/2018 5:23"
        },
        {
            "Locations": "bhalaswa, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7372144",
            "long": "77.1675147",
            "Created At": "10/10/2018 14:08"
        },
        {
            "Locations": "najafgarh, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6181778",
            "long": "77.0032846",
            "Created At": "10/10/2018 11:55"
        },
        {
            "Locations": "shakarpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6358483",
            "long": "77.2863729",
            "Created At": "9/20/2018 5:31"
        },
        {
            "Locations": "rani bagh, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6887433",
            "long": "77.135926",
            "Created At": "8/29/2018 17:15"
        },
        {
            "Locations": "rani bagh, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6887433",
            "long": "77.135926",
            "Created At": "3/7/2018 12:35"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "2/17/2018 12:23"
        },
        {
            "Locations": "bhalaswa, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.7372144",
            "long": "77.1675147",
            "Created At": "2/2/2018 14:53"
        },
        {
            "Locations": "mukherjee nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7159356",
            "long": "77.2195268",
            "Created At": "1/23/2018 6:14"
        },
        {
            "Locations": "saraswati vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7002738",
            "long": "77.1249859",
            "Created At": "1/21/2018 8:46"
        },
        {
            "Locations": "bhalaswa, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7372144",
            "long": "77.1675147",
            "Created At": "1/21/2018 5:09"
        },
        {
            "Locations": "model town, Delhi, India",
            "Crime": "Murders",
            "lat": "28.7077136",
            "long": "77.1989912",
            "Created At": "4/3/2017 1:58"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "3/23/2016 5:45"
        },
        {
            "Locations": "patiala house, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6165835",
            "long": "77.2338029",
            "Created At": "2/9/2021 14:04"
        },
        {
            "Locations": "north avenue, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6235903",
            "long": "77.2000672",
            "Created At": "1/7/2021 8:20"
        },
        {
            "Locations": "connaught place, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6413827",
            "long": "77.2297924",
            "Created At": "12/3/2020 11:29"
        },
        {
            "Locations": "vasant kunj, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5468308",
            "long": "77.1645215",
            "Created At": "9/14/2020 13:45"
        },
        {
            "Locations": "chaukhandi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6463168",
            "long": "77.0994969",
            "Created At": "9/13/2020 8:43"
        },
        {
            "Locations": "connaught place, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6413827",
            "long": "77.2297924",
            "Created At": "9/11/2020 11:39"
        },
        {
            "Locations": "north avenue, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6235903",
            "long": "77.2000672",
            "Created At": "8/11/2020 8:24"
        },
        {
            "Locations": "connaught place, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6413827",
            "long": "77.2297924",
            "Created At": "8/10/2020 8:37"
        },
        {
            "Locations": "connaught place, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6413827",
            "long": "77.2297924",
            "Created At": "8/2/2020 6:10"
        },
        {
            "Locations": "connaught place, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6413827",
            "long": "77.2297924",
            "Created At": "7/27/2020 7:59"
        },
        {
            "Locations": "inderpuri, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6323781",
            "long": "77.1504055",
            "Created At": "7/15/2020 8:21"
        },
        {
            "Locations": "chanakya puri, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6233882",
            "long": "77.2401138",
            "Created At": "7/14/2020 5:32"
        },
        {
            "Locations": "connaught place, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6413827",
            "long": "77.2297924",
            "Created At": "7/2/2020 4:14"
        },
        {
            "Locations": "chanakya puri, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6233882",
            "long": "77.2401138",
            "Created At": "6/24/2020 9:45"
        },
        {
            "Locations": "karol bagh, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.6620158",
            "long": "77.2028422",
            "Created At": "6/5/2020 4:06"
        },
        {
            "Locations": "connaught place, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6413827",
            "long": "77.2297924",
            "Created At": "5/29/2020 13:34"
        },
        {
            "Locations": "chandni chowk, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6561469",
            "long": "77.2354861",
            "Created At": "3/19/2020 13:24"
        },
        {
            "Locations": "connaught place, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6413827",
            "long": "77.2297924",
            "Created At": "1/3/2020 7:09"
        },
        {
            "Locations": "nangloi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6874007",
            "long": "77.0697319",
            "Created At": "4/2/2021 11:19"
        },
        {
            "Locations": "sangam vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6073802",
            "long": "77.0008217",
            "Created At": "4/1/2021 9:40"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "4/1/2021 9:22"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "4/1/2021 9:09"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "4/1/2021 9:08"
        },
        {
            "Locations": "sangam vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6073802",
            "long": "77.0008217",
            "Created At": "4/1/2021 9:08"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "4/1/2021 8:49"
        },
        {
            "Locations": "new friends colony, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5722519",
            "long": "77.278634",
            "Created At": "4/1/2021 8:41"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "3/7/2021 7:41"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "3/7/2021 7:40"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "3/4/2021 16:47"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "3/2/2021 3:57"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "pickpocket",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "3/2/2021 3:06"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "3/2/2021 3:05"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "2/28/2021 6:10"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "2/28/2021 6:09"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "2/28/2021 6:04"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "2/26/2021 9:57"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "2/26/2021 9:57"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "2/26/2021 9:55"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "2/21/2021 8:22"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "2/18/2021 16:47"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "2/18/2021 16:46"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "2/18/2021 16:46"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "2/17/2021 7:14"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "2/17/2021 5:52"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "2/17/2021 5:51"
        },
        {
            "Locations": "ali, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6419097",
            "long": "77.2409817",
            "Created At": "2/17/2021 5:50"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "2/17/2021 5:49"
        },
        {
            "Locations": "mehrauli, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5418262",
            "long": "77.1983232",
            "Created At": "2/17/2021 5:48"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "2/17/2021 5:47"
        },
        {
            "Locations": "new friends colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5722519",
            "long": "77.278634",
            "Created At": "2/17/2021 5:46"
        },
        {
            "Locations": "sangam vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6073802",
            "long": "77.0008217",
            "Created At": "2/17/2021 5:46"
        },
        {
            "Locations": "seelampur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6748165",
            "long": "77.2718137",
            "Created At": "2/17/2021 5:45"
        },
        {
            "Locations": "sangam vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6073802",
            "long": "77.0008217",
            "Created At": "2/8/2021 13:37"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "2/8/2021 13:31"
        },
        {
            "Locations": "new friends colony, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.5722519",
            "long": "77.278634",
            "Created At": "2/8/2021 13:31"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "2/4/2021 12:39"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "2/4/2021 12:37"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "2/4/2021 12:36"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "2/2/2021 16:17"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "2/2/2021 16:15"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "2/2/2021 16:13"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "2/1/2021 6:17"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "2/1/2021 6:16"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "1/31/2021 15:07"
        },
        {
            "Locations": "tehkhand, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5237139",
            "long": "77.2883584",
            "Created At": "1/31/2021 15:04"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/23/2021 16:52"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "1/23/2021 16:48"
        },
        {
            "Locations": "new friends colony, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5722519",
            "long": "77.278634",
            "Created At": "1/20/2021 4:01"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "1/18/2021 13:08"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "1/17/2021 8:39"
        },
        {
            "Locations": "tehkhand, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5237139",
            "long": "77.2883584",
            "Created At": "1/17/2021 8:38"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/17/2021 5:14"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/17/2021 5:10"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/17/2021 5:09"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/15/2021 10:52"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/15/2021 10:52"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/15/2021 10:51"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/11/2021 10:11"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "1/11/2021 10:09"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "1/11/2021 10:06"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/8/2021 12:16"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "1/8/2021 12:16"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "1/7/2021 15:14"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/7/2021 15:09"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "1/5/2021 15:18"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/5/2021 3:13"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "1/5/2021 3:11"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "1/5/2021 3:10"
        },
        {
            "Locations": "vasant kunj, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5468308",
            "long": "77.1645215",
            "Created At": "1/3/2021 9:52"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/3/2021 9:45"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "1/3/2021 9:42"
        },
        {
            "Locations": "east of kailash, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5619823",
            "long": "77.2616181",
            "Created At": "1/3/2021 9:42"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "12/31/2020 12:17"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "12/31/2020 12:16"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Illegal",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "12/31/2020 12:15"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "12/31/2020 12:14"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "12/31/2020 12:13"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "12/31/2020 12:12"
        },
        {
            "Locations": "ali, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6419097",
            "long": "77.2409817",
            "Created At": "12/31/2020 12:11"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "12/28/2020 3:48"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "12/28/2020 3:47"
        },
        {
            "Locations": "jangpura, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5880409",
            "long": "77.2443165",
            "Created At": "12/28/2020 3:45"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "12/23/2020 7:50"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "12/23/2020 7:49"
        },
        {
            "Locations": "pragati maidan, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6284752",
            "long": "77.2475278",
            "Created At": "12/22/2020 8:32"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "12/22/2020 1:28"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "12/20/2020 5:37"
        },
        {
            "Locations": "jangpura, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5880409",
            "long": "77.2443165",
            "Created At": "12/20/2020 5:33"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "12/16/2020 16:49"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "12/16/2020 16:48"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "12/16/2020 16:13"
        },
        {
            "Locations": "seelampur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6748165",
            "long": "77.2718137",
            "Created At": "12/14/2020 7:39"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "12/11/2020 9:27"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "12/11/2020 9:26"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "12/8/2020 13:19"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "11/22/2020 12:09"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "11/22/2020 12:05"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "11/12/2020 17:33"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "11/4/2020 13:13"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "11/4/2020 13:13"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "11/3/2020 9:10"
        },
        {
            "Locations": "maya puri, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6381341",
            "long": "77.2108917",
            "Created At": "11/3/2020 9:07"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "11/2/2020 7:45"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "10/31/2020 10:07"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/31/2020 10:06"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "10/30/2020 9:11"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "10/30/2020 9:01"
        },
        {
            "Locations": "zakir nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5691",
            "long": "77.2786",
            "Created At": "10/28/2020 9:16"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/28/2020 8:13"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/28/2020 8:11"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "10/25/2020 4:23"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/24/2020 21:16"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/22/2020 17:14"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/21/2020 17:59"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "10/21/2020 17:53"
        },
        {
            "Locations": "vasant kunj, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5468308",
            "long": "77.1645215",
            "Created At": "10/19/2020 13:43"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "10/18/2020 15:33"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/17/2020 18:43"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/17/2020 17:28"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/13/2020 10:01"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/5/2020 9:58"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "10/4/2020 7:29"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/4/2020 6:03"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "10/4/2020 6:02"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/4/2020 6:02"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "9/30/2020 15:58"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "9/30/2020 15:55"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "9/24/2020 13:40"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "9/24/2020 13:31"
        },
        {
            "Locations": "ali, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6419097",
            "long": "77.2409817",
            "Created At": "9/24/2020 13:31"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "9/20/2020 5:24"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "9/20/2020 5:23"
        },
        {
            "Locations": "safdarjung enclave, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.569331",
            "long": "77.2007014",
            "Created At": "9/16/2020 14:51"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "9/16/2020 14:49"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "9/15/2020 16:01"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "9/15/2020 15:55"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "9/13/2020 1:28"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "9/9/2020 17:23"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "9/8/2020 16:35"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "9/8/2020 16:28"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "9/3/2020 16:31"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "8/27/2020 17:08"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/26/2020 13:27"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "8/26/2020 13:27"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "8/25/2020 13:38"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "8/23/2020 7:06"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "8/19/2020 17:00"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "8/19/2020 16:17"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "8/19/2020 16:17"
        },
        {
            "Locations": "sangam vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6073802",
            "long": "77.0008217",
            "Created At": "8/19/2020 16:15"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/8/2020 14:09"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/8/2020 14:09"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "8/8/2020 14:09"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "7/30/2020 14:42"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "7/30/2020 14:41"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "7/29/2020 15:09"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "6/12/2020 13:23"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "6/7/2020 6:45"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "5/2/2020 17:29"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "4/11/2020 8:24"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "3/5/2020 17:39"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "3/4/2020 13:04"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/26/2019 18:41"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "7/24/2019 15:30"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "7/10/2019 4:05"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "7/5/2019 19:44"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "3/13/2019 0:44"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "1/26/2019 12:31"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/7/2018 17:34"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "9/14/2018 13:45"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/9/2018 4:50"
        },
        {
            "Locations": "jangpura, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5880409",
            "long": "77.2443165",
            "Created At": "8/8/2018 4:57"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/7/2018 9:09"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "7/22/2018 6:29"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "7/20/2018 5:00"
        },
        {
            "Locations": "east of kailash, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5619823",
            "long": "77.2616181",
            "Created At": "7/19/2018 3:11"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Shooting",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "7/1/2018 5:47"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "6/26/2018 18:43"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "6/26/2018 17:38"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "6/26/2018 5:36"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "5/30/2018 3:44"
        },
        {
            "Locations": "zakir nagar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5691",
            "long": "77.2786",
            "Created At": "5/23/2018 3:20"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "4/18/2018 17:31"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "2/11/2018 16:53"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "2/5/2018 14:40"
        },
        {
            "Locations": "nangloi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6874007",
            "long": "77.0697319",
            "Created At": "4/2/2021 11:19"
        },
        {
            "Locations": "sangam vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6073802",
            "long": "77.0008217",
            "Created At": "4/1/2021 9:40"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "4/1/2021 9:22"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "4/1/2021 9:09"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "4/1/2021 9:08"
        },
        {
            "Locations": "sangam vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6073802",
            "long": "77.0008217",
            "Created At": "4/1/2021 9:08"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "4/1/2021 8:49"
        },
        {
            "Locations": "new friends colony, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5722519",
            "long": "77.278634",
            "Created At": "4/1/2021 8:41"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "3/7/2021 7:41"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "3/7/2021 7:40"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "3/4/2021 16:47"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "3/2/2021 3:57"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "pickpocket",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "3/2/2021 3:06"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "3/2/2021 3:05"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "2/28/2021 6:10"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "2/28/2021 6:09"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "2/28/2021 6:04"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "2/26/2021 9:57"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "2/26/2021 9:57"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "2/26/2021 9:55"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "2/21/2021 8:22"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "2/18/2021 16:47"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "2/18/2021 16:46"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "2/18/2021 16:46"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "2/17/2021 7:14"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "2/17/2021 5:52"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "2/17/2021 5:51"
        },
        {
            "Locations": "ali, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6419097",
            "long": "77.2409817",
            "Created At": "2/17/2021 5:50"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "2/17/2021 5:49"
        },
        {
            "Locations": "mehrauli, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5418262",
            "long": "77.1983232",
            "Created At": "2/17/2021 5:48"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "2/17/2021 5:47"
        },
        {
            "Locations": "new friends colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5722519",
            "long": "77.278634",
            "Created At": "2/17/2021 5:46"
        },
        {
            "Locations": "sangam vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6073802",
            "long": "77.0008217",
            "Created At": "2/17/2021 5:46"
        },
        {
            "Locations": "seelampur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6748165",
            "long": "77.2718137",
            "Created At": "2/17/2021 5:45"
        },
        {
            "Locations": "sangam vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6073802",
            "long": "77.0008217",
            "Created At": "2/8/2021 13:37"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "2/8/2021 13:31"
        },
        {
            "Locations": "new friends colony, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.5722519",
            "long": "77.278634",
            "Created At": "2/8/2021 13:31"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "2/4/2021 12:39"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "2/4/2021 12:37"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "2/4/2021 12:36"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "2/2/2021 16:17"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "2/2/2021 16:15"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "2/2/2021 16:13"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "2/1/2021 6:17"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "2/1/2021 6:16"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "1/31/2021 15:07"
        },
        {
            "Locations": "tehkhand, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5237139",
            "long": "77.2883584",
            "Created At": "1/31/2021 15:04"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/23/2021 16:52"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "1/23/2021 16:48"
        },
        {
            "Locations": "new friends colony, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5722519",
            "long": "77.278634",
            "Created At": "1/20/2021 4:01"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "1/18/2021 13:08"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "1/17/2021 8:39"
        },
        {
            "Locations": "tehkhand, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5237139",
            "long": "77.2883584",
            "Created At": "1/17/2021 8:38"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/17/2021 5:14"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/17/2021 5:10"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/17/2021 5:09"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/15/2021 10:52"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/15/2021 10:52"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/15/2021 10:51"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/11/2021 10:11"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "1/11/2021 10:09"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "1/11/2021 10:06"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/8/2021 12:16"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "1/8/2021 12:16"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "1/7/2021 15:14"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/7/2021 15:09"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "1/5/2021 15:18"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "1/5/2021 3:13"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "1/5/2021 3:11"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "1/5/2021 3:10"
        },
        {
            "Locations": "vasant kunj, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5468308",
            "long": "77.1645215",
            "Created At": "1/3/2021 9:52"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "1/3/2021 9:45"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "1/3/2021 9:42"
        },
        {
            "Locations": "east of kailash, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5619823",
            "long": "77.2616181",
            "Created At": "1/3/2021 9:42"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "12/31/2020 12:17"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "12/31/2020 12:16"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Illegal",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "12/31/2020 12:15"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "12/31/2020 12:14"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "12/31/2020 12:13"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "12/31/2020 12:12"
        },
        {
            "Locations": "ali, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6419097",
            "long": "77.2409817",
            "Created At": "12/31/2020 12:11"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "12/28/2020 3:48"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "12/28/2020 3:47"
        },
        {
            "Locations": "jangpura, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5880409",
            "long": "77.2443165",
            "Created At": "12/28/2020 3:45"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "12/23/2020 7:50"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "12/23/2020 7:49"
        },
        {
            "Locations": "pragati maidan, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6284752",
            "long": "77.2475278",
            "Created At": "12/22/2020 8:32"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "12/22/2020 1:28"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "12/20/2020 5:37"
        },
        {
            "Locations": "jangpura, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5880409",
            "long": "77.2443165",
            "Created At": "12/20/2020 5:33"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "12/16/2020 16:49"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "12/16/2020 16:48"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "12/16/2020 16:13"
        },
        {
            "Locations": "seelampur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6748165",
            "long": "77.2718137",
            "Created At": "12/14/2020 7:39"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "12/11/2020 9:27"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "12/11/2020 9:26"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "12/8/2020 13:19"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "11/22/2020 12:09"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "11/22/2020 12:05"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "11/12/2020 17:33"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "11/4/2020 13:13"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "11/4/2020 13:13"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "11/3/2020 9:10"
        },
        {
            "Locations": "maya puri, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6381341",
            "long": "77.2108917",
            "Created At": "11/3/2020 9:07"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "11/2/2020 7:45"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "10/31/2020 10:07"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/31/2020 10:06"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "10/30/2020 9:11"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "10/30/2020 9:01"
        },
        {
            "Locations": "zakir nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5691",
            "long": "77.2786",
            "Created At": "10/28/2020 9:16"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/28/2020 8:13"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/28/2020 8:11"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "10/25/2020 4:23"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/24/2020 21:16"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/22/2020 17:14"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/21/2020 17:59"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "10/21/2020 17:53"
        },
        {
            "Locations": "vasant kunj, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5468308",
            "long": "77.1645215",
            "Created At": "10/19/2020 13:43"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "10/18/2020 15:33"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/17/2020 18:43"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/17/2020 17:28"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/13/2020 10:01"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/5/2020 9:58"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "10/4/2020 7:29"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/4/2020 6:03"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "10/4/2020 6:02"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "10/4/2020 6:02"
        },
        {
            "Locations": "lal kuan, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5023026",
            "long": "77.284613",
            "Created At": "9/30/2020 15:58"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "9/30/2020 15:55"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "9/24/2020 13:40"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "9/24/2020 13:31"
        },
        {
            "Locations": "ali, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6419097",
            "long": "77.2409817",
            "Created At": "9/24/2020 13:31"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "9/20/2020 5:24"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "9/20/2020 5:23"
        },
        {
            "Locations": "safdarjung enclave, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.569331",
            "long": "77.2007014",
            "Created At": "9/16/2020 14:51"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "9/16/2020 14:49"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "9/15/2020 16:01"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "9/15/2020 15:55"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "9/13/2020 1:28"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "9/9/2020 17:23"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "9/8/2020 16:35"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "9/8/2020 16:28"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "9/3/2020 16:31"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "8/27/2020 17:08"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/26/2020 13:27"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "8/26/2020 13:27"
        },
        {
            "Locations": "madanpur khadar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.54493",
            "long": "77.3105184",
            "Created At": "8/25/2020 13:38"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "8/23/2020 7:06"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "8/19/2020 17:00"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "8/19/2020 16:17"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "8/19/2020 16:17"
        },
        {
            "Locations": "sangam vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6073802",
            "long": "77.0008217",
            "Created At": "8/19/2020 16:15"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/8/2020 14:09"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/8/2020 14:09"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "8/8/2020 14:09"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "7/30/2020 14:42"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "7/30/2020 14:41"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "7/29/2020 15:09"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "6/12/2020 13:23"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "6/7/2020 6:45"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "5/2/2020 17:29"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "4/11/2020 8:24"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "3/5/2020 17:39"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "3/4/2020 13:04"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/26/2019 18:41"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "7/24/2019 15:30"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "7/10/2019 4:05"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "7/5/2019 19:44"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "3/13/2019 0:44"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "1/26/2019 12:31"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "10/7/2018 17:34"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "9/14/2018 13:45"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/9/2018 4:50"
        },
        {
            "Locations": "jangpura, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5880409",
            "long": "77.2443165",
            "Created At": "8/8/2018 4:57"
        },
        {
            "Locations": "amar colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.5633973",
            "long": "77.245909",
            "Created At": "8/7/2018 9:09"
        },
        {
            "Locations": "jaitpur, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5004221",
            "long": "77.3154702",
            "Created At": "7/22/2018 6:29"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "7/20/2018 5:00"
        },
        {
            "Locations": "east of kailash, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5619823",
            "long": "77.2616181",
            "Created At": "7/19/2018 3:11"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Shooting",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "7/1/2018 5:47"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "6/26/2018 18:43"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "6/26/2018 17:38"
        },
        {
            "Locations": "sarita vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5335737",
            "long": "77.2933311",
            "Created At": "6/26/2018 5:36"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "5/30/2018 3:44"
        },
        {
            "Locations": "zakir nagar, Delhi, India",
            "Crime": "Murders",
            "lat": "28.5691",
            "long": "77.2786",
            "Created At": "5/23/2018 3:20"
        },
        {
            "Locations": "nizamuddin, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6009417",
            "long": "77.2523341",
            "Created At": "4/18/2018 17:31"
        },
        {
            "Locations": "kalkaji, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.5488923",
            "long": "77.2688023",
            "Created At": "2/11/2018 16:53"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "2/5/2018 14:40"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "4/9/2021 11:53"
        },
        {
            "Locations": "gulabi bagh, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6696995",
            "long": "77.1947756",
            "Created At": "3/24/2021 11:22"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "3/21/2021 13:30"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "3/18/2021 10:46"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "3/16/2021 6:15"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "3/16/2021 6:07"
        },
        {
            "Locations": "ashok vihar, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6995033",
            "long": "77.1848756",
            "Created At": "3/10/2021 10:18"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "3/10/2021 8:04"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "3/5/2021 7:02"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Murders",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "2/27/2021 16:15"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "2/27/2021 8:18"
        },
        {
            "Locations": "gulabi bagh, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.6696995",
            "long": "77.1947756",
            "Created At": "2/26/2021 12:19"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Murders",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "2/26/2021 12:05"
        },
        {
            "Locations": "roop nagar, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.688098",
            "long": "77.2035347",
            "Created At": "2/26/2021 12:00"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "2/21/2021 18:19"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "2/19/2021 7:58"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "2/18/2021 10:50"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "2/18/2021 10:49"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "2/17/2021 13:13"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "2/16/2021 6:27"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "2/13/2021 8:12"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "2/13/2021 8:07"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "2/6/2021 9:47"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "2/6/2021 9:45"
        },
        {
            "Locations": "krishna nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.564727",
            "long": "77.1961682",
            "Created At": "2/3/2021 6:36"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "2/2/2021 6:18"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "2/2/2021 6:09"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "1/19/2021 13:48"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "1/19/2021 13:44"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "1/15/2021 10:58"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Murders",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "1/14/2021 12:00"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Theft",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "1/12/2021 10:48"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Murders",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "1/12/2021 10:37"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "1/2/2021 16:20"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "1/2/2021 15:11"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "1/2/2021 14:48"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Theft",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "12/28/2020 12:43"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "12/16/2020 17:03"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "12/12/2020 11:18"
        },
        {
            "Locations": "jamia nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7718638",
            "long": "77.3476629",
            "Created At": "12/7/2020 12:52"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "12/5/2020 12:44"
        },
        {
            "Locations": "gulabi bagh, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6696995",
            "long": "77.1947756",
            "Created At": "12/2/2020 16:52"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "12/1/2020 12:09"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "12/1/2020 11:46"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "11/19/2020 11:31"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "11/13/2020 12:31"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "11/4/2020 4:25"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "10/31/2020 13:02"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "10/27/2020 12:40"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "10/27/2020 12:39"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Murders",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "10/27/2020 12:17"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "10/27/2020 12:13"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Murders",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "10/26/2020 15:28"
        },
        {
            "Locations": "roop nagar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.688098",
            "long": "77.2035347",
            "Created At": "10/26/2020 15:06"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "10/17/2020 10:37"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "10/13/2020 17:41"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Illegal",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "10/12/2020 14:52"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "10/9/2020 15:04"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "10/7/2020 17:12"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "10/6/2020 11:04"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "10/6/2020 11:00"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "10/3/2020 17:42"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "9/28/2020 16:02"
        },
        {
            "Locations": "chandni chowk, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6561469",
            "long": "77.2354861",
            "Created At": "9/25/2020 16:54"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "9/25/2020 16:30"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "9/22/2020 14:53"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "9/16/2020 17:31"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "9/16/2020 17:08"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "9/14/2020 14:59"
        },
        {
            "Locations": "roop nagar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.688098",
            "long": "77.2035347",
            "Created At": "9/11/2020 15:28"
        },
        {
            "Locations": "gulabi bagh, Delhi, India",
            "Crime": "Bootlegger",
            "lat": "28.6696995",
            "long": "77.1947756",
            "Created At": "9/11/2020 15:00"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "9/9/2020 16:20"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "9/8/2020 7:40"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "9/7/2020 16:48"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Theft",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "9/7/2020 16:44"
        },
        {
            "Locations": "bazar road, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5933664",
            "long": "77.1207397",
            "Created At": "9/2/2020 14:01"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "8/28/2020 12:18"
        },
        {
            "Locations": "hauz qazi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6473149",
            "long": "77.2309034",
            "Created At": "8/27/2020 4:41"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "8/26/2020 4:25"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "8/24/2020 9:20"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "8/23/2020 6:15"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "8/12/2020 9:16"
        },
        {
            "Locations": "roop nagar, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.688098",
            "long": "77.2035347",
            "Created At": "7/29/2020 5:39"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "7/28/2020 3:03"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "7/16/2020 14:50"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "7/14/2020 10:23"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "7/13/2020 3:22"
        },
        {
            "Locations": "shahdara, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6783333",
            "long": "77.2940248",
            "Created At": "7/7/2020 19:32"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "7/6/2020 13:23"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "7/5/2020 10:53"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "7/5/2020 7:14"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "7/4/2020 16:53"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "7/3/2020 10:41"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "6/13/2020 11:54"
        },
        {
            "Locations": "chandni chowk, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6561469",
            "long": "77.2354861",
            "Created At": "5/24/2020 8:42"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "4/19/2020 8:35"
        },
        {
            "Locations": "roop nagar, Delhi, India",
            "Crime": "Burglary",
            "lat": "28.688098",
            "long": "77.2035347",
            "Created At": "3/7/2020 4:49"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "3/6/2020 12:02"
        },
        {
            "Locations": "geeta colony, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6553154",
            "long": "77.279397",
            "Created At": "3/6/2020 11:41"
        },
        {
            "Locations": "sarai rohilla, Delhi, India",
            "Crime": "Theft",
            "lat": "28.6654272",
            "long": "77.204228",
            "Created At": "2/14/2020 4:57"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "9/15/2019 3:54"
        },
        {
            "Locations": "majnu ka tila, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.7186766",
            "long": "77.2460118",
            "Created At": "12/31/2018 16:24"
        },
        {
            "Locations": "delhi university, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.7996668",
            "long": "77.0366938",
            "Created At": "10/23/2018 13:50"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "9/6/2018 13:02"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "9/6/2018 5:31"
        },
        {
            "Locations": "mandi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.4439546",
            "long": "77.1471062",
            "Created At": "9/5/2018 15:20"
        },
        {
            "Locations": "burari, Delhi, India",
            "Crime": "Illegal",
            "lat": "28.7695818",
            "long": "77.2251423",
            "Created At": "8/3/2018 17:18"
        },
        {
            "Locations": "gulabi bagh, Delhi, India",
            "Crime": "Drugs",
            "lat": "28.6696995",
            "long": "77.1947756",
            "Created At": "6/26/2017 14:29"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "6/19/2017 12:11"
        },
        {
            "Locations": "timarpur, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.7088696",
            "long": "77.2260784",
            "Created At": "6/14/2017 13:06"
        },
        {
            "Locations": "gulabi bagh, Delhi, India",
            "Crime": "Snatched",
            "lat": "28.6696995",
            "long": "77.1947756",
            "Created At": "6/5/2017 9:36"
        },
        {
            "Locations": "ranhola, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6601084",
            "long": "77.0386875",
            "Created At": "4/1/2021 11:01"
        },
        {
            "Locations": "nangloi, Delhi, India",
            "Crime": "pickpocket",
            "lat": "28.6874007",
            "long": "77.0697319",
            "Created At": "3/24/2021 15:38"
        },
        {
            "Locations": "nangloi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6874007",
            "long": "77.0697319",
            "Created At": "3/2/2021 16:05"
        },
        {
            "Locations": "nangloi, Delhi, India",
            "Crime": "Robbed",
            "lat": "28.6874007",
            "long": "77.0697319",
            "Created At": "12/10/2020 10:49"
        },
        {
            "Locations": "paschim vihar, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6808923",
            "long": "77.1197404",
            "Created At": "8/7/2020 4:01"
        },
        {
            "Locations": "nangloi, Delhi, India",
            "Crime": "Arrested",
            "lat": "28.6874007",
            "long": "77.0697319",
            "Created At": "7/12/2020 6:34"
        },
        {
            "Locations": "paschim vihar, Delhi, India",
            "Crime": "Criminal",
            "lat": "28.6808923",
            "long": "77.1197404",
            "Created At": "6/10/2020 12:58"
        },
        {
            "Locations": "begumpur, Delhi, India",
            "Crime": "Theft",
            "lat": "28.5370282",
            "long": "77.2099906",
            "Created At": "3/16/2016 3:32"
        }
    ]
